// SX Market Filter Constants based on transformSxMarkets.ts

export interface SxMarketFilterOption {
  id: string
  label: string
  value: string
  marketTypes: string[] // SX market types to match
}

/**
 * Format market type for display by removing underscores and capitalizing properly
 */
export const formatMarketNameForDisplay = (marketType: string): string => {
  // Handle special cases first
  const specialCases: Record<string, string> = {
    MONEY_LINE: "Money Line",
    OVER_UNDER: "Over/Under",
    TIE_1X2: "1X2",
    TEAM_ONE_1X2: "1X2",
    TEAM_TWO_1X2: "1X2",
  }

  if (specialCases[marketType]) {
    return specialCases[marketType]
  }

  // For other market types, replace underscores with spaces and capitalize
  return marketType
    .toLowerCase()
    .split("_")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}

export const SX_MARKET_FILTER_CONSTANTS: SxMarketFilterOption[] = [
  {
    id: "money_line",
    label: "Money Line",
    value: "money_line",
    marketTypes: ["MONEY_LINE"],
  },
  {
    id: "spread",
    label: "Spread",
    value: "spread",
    marketTypes: ["SPREAD"],
  },
  {
    id: "over_under",
    label: "Over/Under",
    value: "over_under",
    marketTypes: ["OVER_UNDER"],
  },
  {
    id: "1x2",
    label: "1X2",
    value: "1x2",
    marketTypes: ["TIE_1X2", "TEAM_ONE_1X2", "TEAM_TWO_1X2"],
  },
]

export const DEFAULT_SX_SELECTED_MARKET = "money_line"

export const getSxMarketTypesFromFilterValue = (
  filterValue: string
): string[] => {
  const filter = SX_MARKET_FILTER_CONSTANTS.find(f => f.value === filterValue)
  return filter?.marketTypes || []
}

export const isSxMarketTypeVisible = (
  marketType: string,
  selectedFilters: string[]
): boolean => {
  if (selectedFilters.length === 0) {
    return false
  }

  return selectedFilters.some(filterValue => {
    const marketTypes = getSxMarketTypesFromFilterValue(filterValue)
    return marketTypes.includes(marketType)
  })
}
